import { Col, Container } from "react-bootstrap";
import SectionHeading from "../ui/SectionHeading";
import { RevealGroup, RevealItem } from "../ui/Reveal";
import "../style/Testimonials.css";

const REVIEWS = [
  {
    name: "Geeta Girija",
    role: "Social worker, Bagalkot",
    photo: "/images/review/GeetaGirijaReview.jpg",
    quote:
      "Your good, nutritious and delicious breakfast is appreciated by all. In the modern age when everyone is going to work, the batter you prepare is very good when you want to make quick idli and dosa.",
  },
  {
    name: "Prof. N. M. Koogali",
    role: "Proud customer",
    photo: "/images/review/KoogliSirReview.jpg",
    quote:
      "Another name for breakfast and quality food is Kote Cafe. Idli, sambar, chatti, soft vade, crispy dosa — it satisfies everyone's needs.",
  },
];

const Testimonials = () => {
  return (
    <section className="section-pad testimonials">
      <Container className="container-narrow">
        <SectionHeading eyebrow="From Our Customers" title="Trusted at the Breakfast Table" />
        <RevealGroup className="row g-4 justify-content-center">
          {REVIEWS.map(({ name, role, photo, quote }, i) => (
            <Col sm={10} md={6} lg={5} key={name}>
              <RevealItem delay={i * 100} className="testimonials__card card-surface">
                <img src={photo} alt={name} className="testimonials__photo" />
                <p className="testimonials__quote">&ldquo;{quote}&rdquo;</p>
                <div className="testimonials__name">{name}</div>
                <div className="testimonials__role">{role}</div>
              </RevealItem>
            </Col>
          ))}
        </RevealGroup>
      </Container>
    </section>
  );
};

export default Testimonials;
